import { useSelector } from 'react-redux';
import { payment_depositIframe, payment_depositType, payment_depositTabs } from 'store/payment/selectors';
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { Pages } from 'interfaces/main';

export const useIsPspIframeOpen = () => {
    const iframeUrl = useSelector(payment_depositIframe);
    const depositType = useSelector(payment_depositType);
    const depositTabs = useSelector(payment_depositTabs);
    const { pathname, search } = useLocation();

    return useMemo(() => {
        const params = new URLSearchParams(search);
        const hasGoalId = params.has('goalId');
        const hasPackageId = params.has('packageId');
        const isCheckoutPath = pathname.includes(`/prop/${Pages.PROP__CHECKOUT}`);

        if (!isCheckoutPath || !hasGoalId || !hasPackageId) {
            return false;
        }

        if (!iframeUrl) {
            return false;
        }

        if (depositType && depositTabs[depositType.tabName]) {
            const currentTab = depositTabs[depositType.tabName];
            return currentTab.isIframe && !currentTab.iframeNewTab;
        }

        return false;
    }, [iframeUrl, depositType, depositTabs, pathname, search]);
};
